export const OCC_USER_ID_CURRENT = 'current';
export const OCC_USER_ID_ANONYMOUS = 'anonymous';
export const OCC_USER_ID_GUEST = 'guest';

export const OCC_CART_ID_CURRENT = 'current';
